export default {
	lang:'de',
	download:{
		"download01":"Windows",
		"download02":"Mac",
		"download03":"iOS",
		"download04":"Android",
		"download05":"Jetzt herunterladen",
		"download":"herunterladen",
		"download2":"Mobile",
		"download3":"Scannen Sie den QR-Code, um iOS/Android herunterzuladen",
		"download4":"QR-Code",
		"download5":"Windows",
		"download6":"Unterstützt 64-Bit-Windows 10 und höher",
		"download7":"macOS",
		"download8":"Unterstützt MacOS 10.14 und höher",
		"download9":"App Store",
		"download10":"Unterstützt MacOS 10.14 und höher",
		"download11":"Android",
		"download12":"Unterstützt Android 10.14 und höher",
	},
	home:{
		"home":"Titelseite",
		"XiaobeiBigModel":"Kleines Modell",
		"AIcapability":"KI-Funktionen",
		"Solution":"Lösung",
		"ProductCenter":"Produktcenter",
		"MediaCenter":"Medienzentrum",
		"AboutUs":"über uns",
		"Login/Regis":"Anmelden/Registrieren",
		"home1":"Kernkompetenzen",
		"home2":"Kundenservice-Hotline",
		"home3":"Kontaktnummer",
		"home14":"KI-Empowerment, das intelligente Hardware als Träger nutzt, bietet Full-Stack-Funktionen und -Dienste",
		"home15":"Jigsaw-Algorithmus",
		"home16":"OCR-Erkennung",
		"home17":"KI-Intelligenz",
		"home18":"Spracherkennung",
		"home19":"Autoritatives Wörterbuch",
		"home20":"Textübersetzung",
		"home21":"Fotoübersetzung",
		"home22":"Allgemeine Fragen und Antworten",
		"home23":"Videokurse",
		"home24":"Xiaobei AI großes Modell",
		"home25":"Technologie ist die primäre Produktivkraft",
		"home26":"Technisches Personal",
		"home27":"F&E-Investitionen",
		"home28":"Anzahl der Patente",
		"home29":"(Prozentsatz)",
		"home30":"(100 Millionen Yuan)",
		"home31":"(Artikel)",
		"home32":"Lösung",
		"home33":"Angesichts der Anwendungsanforderungen in zahlreichen Szenarien, beispielsweise im Büro, im Bildungsbereich und im Auto, bietet BeiBo seinen Kunden Komplettlösungen auf Grundlage seiner eigenen Forschungs- und Entwicklungskapazitäten und Servicekonzepte.",
		"home34":"Verwandte Lösungen",
		"home35":"Zugehörige Produktfunktionen",
		"home36":"Full-Stack-Dienste",
		"home37":"KI-Empowerment, das intelligente Hardware als Träger nutzt, bietet Full-Stack-Funktionen und -Dienste",
		"home38":"Forschung und Entwicklung",
		"home39":"Produktion",
		"home40":"Qualitätsmanagement",
		"home41":"Kundendienst",
		"home42":"Professionelles Software- und Hardware-Forschungs- und Entwicklungsteam mit langjähriger Forschungs- und Entwicklungserfahrung in den Bereichen OCR, Spracherkennung, Übersetzung, KI und Mensch-Computer-Interaktion",
		"home43":"Quellfabrik, stabile Lieferkette, streng intelligente Prozessproduktion",
		"home44":"Qualitätsinspektoren überprüfen jeden Schritt und führen das ISO9001-Managementsystem ein",
		"home45":"Bilden Sie im In- und Ausland professionelle Kundendienstteams, um zeitnahe Reaktionen, zielgerichtete Lösungen und individuellen Service zu gewährleisten.",
		"home46":"Zertifizierung",
		"home47":"Mehr als 100 in- und ausländische Patente",
		"home48":"Nachricht",
		"home49":"Erfahren Sie mehr über unsere neuesten Nachrichten",
		"home50":"Details ansehen",
		"home51":"Partner-Angebote",
		"home52":"Konzentrieren Sie sich auf den Markt für künstliche Intelligenz-Hardware und bieten Sie professionelle OEM/0DM-Dienste an",
		"home53":"Kooperationsberatung",
		"home54":"Intelligentes Büro",
		"home55":"Intelligente Bildung",
		"home56":"Smart Car Box",
		"home57":"Spracherkennung",
		"home58":"Jigsaw-Algorithmus",
		"home59":"OCR-Erkennung",
		"home60":"Sprachsynthese",
		"home61":"Textübersetzung",
		"home62":"Bildübersetzung",
		"home63":"Sprachübersetzung",
		"home64":"Verarbeitung natürlicher Sprache",
		"home571":"OCR-Erkennung",
		"home581":"Spracherkennung ",
		"home591":"Sprachübersetzung",
		"home601":"Sprachsynthese",
		"home611":"Autoritatives Wörterbuch",
		"home621":"Allgemeine Kurse",
		"home631":"Allgemeine Fragen und Antworten",
		"home641":"Verarbeitung natürlicher Sprache",
		"home572":"Spracherkennung",
		"home582":"Sprachsynthese ",
		"home592":"Sprachübersetzung",
		"home602":"Verarbeitung natürlicher Sprache",
		"home603":"Nicht mehr",
		
	},
	consult:{
		"tilte":"Wir werden Ihnen von ganzem Herzen eine umfassende Palette von Dienstleistungen für die Geschäftszusammenarbeit anbieten",
		"subtilte":"Bitte hinterlassen Sie Ihre Kontaktdaten und wir werden Sie so schnell wie möglich kontaktieren",
		"name":"Bitte geben Sie Ihren Namen ein",
		"phone":"Bitte geben Sie Ihre Telefonnummer ein",
		"mailbox":"Bitte geben Sie Ihre E-Mail ein",
		"mailboxerr":"Fehler im E-Mail-Format",
		"company":"Bitte geben Sie Ihre Firma ein",
		"desc":"Bitte geben Sie Ihre Anforderungen ein",
		"but":"Übermittlung bestätigen",
		"region":"China",
		"select":"Bitte wählen",
		"submitSuccess":"Erfolgreich abgeschickt",
		"submitError":"Senden fehlgeschlagen",
	},
	ProDetails:{
		"ProDetails1": '定制流程',
		"ProDetails2": '聚焦人工智能硬件市场，提供专业OEM/0DM服务',
	},
	aiCapacity:{
		"aiMode1":"KI-Funktionen",
		"aiMode2":"Basierend auf Technologien wie Big Data, Wissensgraphen, maschinellem Lernen und Linguistik entwickeln wir uns weiter und konzentrieren uns auf die Erforschung von KI-Kerntechnologien und die Implementierung intelligenter Hardwareanwendungen.",
		"aiMode3":"Kooperationsberatung",
		"aiMode4":"Kernkompetenzen",
		"aiMode5":"KI-Empowerment, das intelligente Hardware als Träger nutzt, bietet Full-Stack-Funktionen und -Dienste",
		"aiMode6":"Jigsaw-Algorithmus",
		"aiMode7":"Fügen Sie kleine fragmentierte Bilder zur Erkennung zu großen Bildern zusammen und unterstützen Sie über 50 Sprachen",
		"aiMode8":"OCR-Erkennung",
		"aiMode9":"Extrahieren Sie Text durch Bildverarbeitung und Mustererkennung. Unterstützt über 50 Sprachen",
		"aiMode10":"Spracherkennung",
		"aiMode11":"Präzise Erkennung von langen und kurzen Audiodaten im Text. Unterstützt über 130 Sprachen.",
		"aiMode12":"Sprachsynthese",
		"aiMode13":"Wandeln Sie Text in eine natürliche und flüssige menschliche Stimme um. Unterstützt über 130 Sprachen",
		"aiMode14":"Textübersetzung",
		"aiMode15":"Konvertieren Sie Text aus der Zielsprache in die angegebene Sprache. Unterstützt über 130 Sprachen",
		"aiMode16":"Bildübersetzung",
		"aiMode17":"Bildtexterkennung und -übersetzung. Unterstützt über 130 Sprachen",
		"aiMode18":"Sprachübersetzung",
		"aiMode19":"Präzise Erkennung und Übersetzung langer und kurzer Audiodateien. Unterstützt über 130 Sprachen.",
		"aiMode20":"Verarbeitung natürlicher Sprache",
		"aiMode21":"Basierend auf Big Data, Wissen und Sprachtechnologie können Anwendungen wie Fragen-Beantwortung und Dialog realisiert werden",
		"aiMode22":"Wörterbuchautorität",
		"aiMode23":"Enge Zusammenarbeit mit maßgeblichen Institutionen, um authentische Wörterbücher wie Oxford, Longman und verschiedene Minderheitensprachen bereitzustellen",
		"aiMode24":"Videokurse",
		"aiMode25":"Fachübergreifende Videokurse, parallel aktualisierte Lehrbücher, geeignet zur Vorschau und Wiederholung",
		"aiMode26":"Allgemeine Fragen und Antworten",
		"aiMode27":"Beantworten Sie Fragen und interpretieren Sie Fragen in allen Fächern, lernen Sie durch Analogie und verbessern Sie die Lerneffizienz",
		"aiMode28":"Xiaobei AI großes Modell",
		"aiMode29":"Multimodale Interaktion",
		"aiMode30":"Multimodale Interaktion per Text, Sprache und Video",
		"aiMode31":"Programmierkenntnisse",
		"aiMode32":"Codegenerierung, Interpretation, Debugging, Testen",
		"aiMode33":"Textgenerierung",
		"aiMode34":"Erstellung von Aufsätzen, Marketing, Pressemitteilungen etc.",
		"aiMode35":"Allgemeinmedizin",
		"aiMode36":"Fragenstellung und Problemlösung für alle Fächer",
		"aiMode37":"Sprachverständnis",
		"aiMode38":"Abstrakte Extraktion, Grammatikprüfung, Stimmungsanalyse",
		"aiMode39":"Wissenswertes",
		"aiMode40":"Wissen über Leben, Arbeit, Medizin und Geschichte",
		"aiMode41":"Logisches Denken",
		"aiMode42":"Denken, Wissenschaft, gesunder Menschenverstand",
		"aiMode43":"Mehrsprachig",
		"aiMode44":"Unterstützt die Interaktion in mehr als 100 Sprachen",
		"aiMode45":"Technische Vorteile",
		"aiMode46":"200 Millionen genaue Korpus",
		"aiMode47":"Weit verbreitet in Smart Office, Smart Education, Smart Car Box",
		"aiMode48":"Globale kollaborative Technologie",
		"aiMode49":"Ultraniedrige Latenz, sicher und stabil, intelligente Planung, stabile Verbindung",
		"aiMode50":"Sicherheitsverschlüsselungssystem",
		"aiMode51":"International führendes vierdimensionales Cloud-Pipe-End-Data-Verschlüsselungssystem, Vollprozessverschlüsselung",
	},
	aiMode:{
		"aiMode1":"KI-Funktionen",
		"aiMode2":"Basierend auf Technologien wie Big Data, Wissensgraphen, maschinellem Lernen und Linguistik entwickeln wir uns weiter und konzentrieren uns auf die Erforschung von KI-Kerntechnologien und die Implementierung intelligenter Hardwareanwendungen.",
		"aiMode3":"Kooperationsberatung",
		"aiMode4":"Kernkompetenzen",
		"aiMode5":"KI-Empowerment, das intelligente Hardware als Träger nutzt, bietet Full-Stack-Funktionen und -Dienste",
		"aiMode6":"Jigsaw-Algorithmus",
		"aiMode7":"Fügen Sie kleine fragmentierte Bilder zur Erkennung zu großen Bildern zusammen und unterstützen Sie über 50 Sprachen",
		"aiMode8":"OCR-Erkennung",
		"aiMode9":"Extrahieren Sie Text durch Bildverarbeitung und Mustererkennung. Unterstützt über 50 Sprachen",
		"aiMode10":"Spracherkennung",
		"aiMode11":"Präzise Erkennung von langen und kurzen Audiodaten im Text. Unterstützt über 130 Sprachen.",
		"aiMode12":"Sprachsynthese",
		"aiMode13":"Wandeln Sie Text in eine natürliche und flüssige menschliche Stimme um. Unterstützt über 130 Sprachen",
		"aiMode14":"Textübersetzung",
		"aiMode15":"Konvertieren Sie Text aus der Zielsprache in die angegebene Sprache. Unterstützt über 130 Sprachen",
		"aiMode16":"Bildübersetzung",
		"aiMode17":"Bildtexterkennung und -übersetzung. Unterstützt über 130 Sprachen",
		"aiMode18":"Sprachübersetzung",
		"aiMode19":"Präzise Erkennung und Übersetzung langer und kurzer Audiodateien. Unterstützt über 130 Sprachen.",
		"aiMode20":"Verarbeitung natürlicher Sprache",
		"aiMode21":"Realisieren Sie Frage-Antwort-, Dialog- und andere Anwendungen basierend auf Big Data, Wissen und Sprachtechnologieverständnis",
		"aiMode22":"Wörterbuchautorität",
		"aiMode23":"Enge Zusammenarbeit mit maßgeblichen Institutionen, um authentische Wörterbücher wie Oxford, Longman und verschiedene Minderheitensprachen bereitzustellen",
		"aiMode24":"Videokurse",
		"aiMode25":"Fachübergreifende Videokurse, parallel aktualisierte Lehrbücher, geeignet zur Vorschau und Wiederholung",
		"aiMode26":"Allgemeine Fragen und Antworten",
		"aiMode27":"Beantworten Sie Fragen und interpretieren Sie Fragen in allen Fächern, lernen Sie durch Analogie und verbessern Sie die Lerneffizienz",
		"aiMode28":"Xiaobei AI großes Modell",
		"aiMode29":"Multimodale Interaktion",
		"aiMode30":"Multimodale Interaktion per Text, Sprache und Video",
		"aiMode31":"Programmierkenntnisse",
		"aiMode32":"Codegenerierung, Interpretation, Debugging, Testen",
		"aiMode33":"Textgenerierung",
		"aiMode34":"Erstellung von Aufsätzen, Marketing, Pressemitteilungen etc.",
		"aiMode35":"Allgemeinmedizin",
		"aiMode36":"Fragenstellung und Problemlösung für alle Fächer",
		"aiMode37":"Sprachverständnis",
		"aiMode38":"Abstrakte Extraktion, Grammatikprüfung, Stimmungsanalyse",
		"aiMode39":"Wissenswertes",
		"aiMode40":"Wissen über Leben, Arbeit, Medizin und Geschichte",
	},
	Product:{
		"Product1":"Produktcenter",
		"Product2":"Büro-, Bildungs- und intelligente Produkte für das Fahrzeug, Unterstützung bei der Bestellung und Funktionsanpassung",
		"Product3":"Kooperationsberatung",
	},
	medium:{
		"medium1":"Medienzentrum",
		"medium2":"Die neuesten Nachrichten von BeiBo finden Sie hier",
		"medium3":"Kooperationsberatung",
	},
	about:{
		"about1":"Erfahren Sie mehr über BeiBo",
		"about2":"Anbieter intelligenter Hardwarelösungen für Büro, Bildung, Carbox usw.",
		"about3":"Kooperationsberatung",
		"about4":"Unternehmensprofil",
		"about5":"Zertifizierung",
		"about6":"Mehr als 100 in- und ausländische Patente",
		"about7":"Shenzhen Beibo Intelligent Technology Co., Ltd.",
		"about8":"BeiBo Intelligent wurde 2015 gegründet und hat seinen Sitz in Shenzhen, Chinas Zentrum für „intelligente Fertigung“. Das Unternehmen ist ein nationales Hightech-Unternehmen und ein spezialisiertes und innovatives Unternehmen mit einer zukunftsorientierten Vision und Innovationsgeist.",
		"about9":"Das Unternehmen konzentriert sich auf das vertikale Segment der KI-Sprache und verfügt über starke Forschungs- und Entwicklungskapazitäten für KI-Software und -Hardware. Es stärkt KI-Hardware durch den Export von KI-Technologien wie KI-Sprache, KI-Übersetzung, KI-OCR, KI-Mensch-Fahrzeug-Interaktion und KI-Cloud. Das Unternehmen entwickelt ein eigenes KI-Modell für Sprachübersetzung, integriert die neuesten KI-Multimodal- und AIGC-Technologien und bietet Kunden in verschiedenen Branchen umfassende KI-Sprachtechnologielösungen basierend auf Forschung und Entwicklung sowie Design von Chipplattformen und Hardwarelösungen. In den Bereichen Bildung, Regierung, Unternehmen und Militär verfügt das Unternehmen über ausgereifte Branchenlösungen. Im Verbraucherbereich übersteigt der Jahresabsatz von KI-Hardware wie KI-Übersetzern, KI-Diktiergeräten, KI-Scannern und KI-Autoboxen eine Million Einheiten. Das Unternehmen hat zahlreiche strategische Partner in Japan, Europa, den USA und anderen Ländern und Regionen, um Menschen bei der Überwindung von Sprachbarrieren zu unterstützen, und ist ein weltweit führender Anbieter von KI-Sprachtechnologielösungen.",
		"about10":"",
	},
	footer:{
		"AboutUs":"über uns",
		"CollaborativeConsulting":"Kooperationsberatung",
		"Businesscooperation":"Geschäftskooperation",
		"phone":"Bitte geben Sie Ihre Telefonnummer ein",
		"phone2":"+86 13660736734",
		"phone3":"hangou@szbbzn.com",
		"tel":"0755 27189290",
		"address":"Raum 201, Gebäude F, Industriegebiet Yuanfen, Gemeinde Taoyuan, Dalang-Straße, Bezirk Longhua, Shenzhen",
		"copyright":"Urheberrecht © Shenzhen Beibo Intelligent Technology Co., Ltd.",
		"icp":"Guangdong ICP Nr. 2024241358-1",
		"footer2":"Willkommen zur Registrierung",
		"footer3":"Hast du schon ein Konto?",
		"footer4":"Bitte einloggen",
	},
	login:{
		"login1":"Passwort-Login",
		"login2":"SMS-Anmeldung",
		"loginTab3":"E-Mail-Anmeldung",
		"login3":"Mail",
		"login4":"Login-Passwort",
		"login5":"Telefonnummer",
		"login6":"Bitte wählen",
		"login7":"Mobiler Bestätigungscode",
		"login8":"Einloggen",
		"login9":"Passwort vergessen",
		"login10":"registrieren",
		"login11":"Mit der Anmeldung erklären Sie sich einverstanden",
		"login12":"Servicevereinbarung",
		"login13":"Datenschutzrichtlinie",
		"login14":"Erhalten",
		"login15":"China",
		"login16":"Bitte geben Sie Ihre Kontonummer ein",
		"login17":"Bitte geben Sie Ihr Passwort ein",
		"login18":"Erfolgreich angemeldet!",
		"login19":"Bitte geben Sie den Bestätigungscode ein!",
		"login20":"Erfolgreich gesendet!",
		"login21":"Und",
		"login22":"Sprachrekorder-Cloud-Disk",
		"login23":"Mein Schreiben",
		"login24":"Mein Gespräch",
		"login25":"Kontosicherheit",
		"login26":"Ausloggen",
		"login27":"Passwort per E-Mail abrufen",
		"login28":"Mail",
		"login29":"E-Mail-Bestätigungscode",
		"login30":"Legen Sie ein Login-Passwort fest (6-16 Zeichen)",
		"login31":"Geben Sie Ihr Login-Passwort erneut ein",
		"login32":"einreichen",
		"login33":"Zurück zur Anmeldung",
		"login34":"Änderung erfolgreich!",
	},
	register:{
		"register1":"Telefonnummer",
		"register2":"Bitte geben Sie Ihre Telefonnummer ein",
		"register3":"Bitte wählen",
		"register4":"Mobiler Bestätigungscode",
		"register5":"Passwort festlegen",
		"register6":"Bitte geben Sie den Bestätigungscode ein",
		"register7":"6-16 Zeichen",
		"register8":"Passwortbestätigung",
		"register9":"Mail",
		"register10":"Bitte geben Sie Ihre E-Mail-Adresse ein",
		"register11":"E-Mail-Bestätigungscode",
		"register12":"Bitte geben Sie den Bestätigungscode ein",
		"register13":"Ich habe gelesen und stimme zu",
		"register14":"Bitte lesen Sie und kreuzen Sie das Kästchen an, mit dem Sie der Vereinbarung zustimmen",
		"register15":"Das Telefonnummernformat ist falsch/die Telefonnummer wurde registriert",
		"register16":"Fehler beim mobilen Bestätigungscode",
		"register17":"Bitte geben Sie Ihre E-Mail-Adresse ein. / Das Format der E-Mail-Adresse ist falsch.",
		"register18":"Fehler im E-Mail-Format",
		"register19":"Fehler beim E-Mail-Bestätigungscode",
		"register20":"Bitte legen Sie das Passwort auf 6-16 Zeichen fest",
		"register21":"Fehler im Kennwortformat",
		"register22":"Die von Ihnen zweimal eingegebenen Passwörter stimmen nicht überein. Bitte wiederholen Sie die Eingabe.",
		"register23":"Bitte geben Sie Ihr Passwort ein",
		"register24":"Registrierung erfolgreich!",
		"register25":"Fehler beim Bestätigungscode",
	},
	recorder:{
		"recorder1":"Sprachrekorder-Cloud-Disk",
		"recorder2":"Cloud-Speicherplatzkapazität",
		"recorder3":"dokumentieren",
		"recorder331":"Papierkorb",
		"recorder332":"Alles löschen",
		"recorder4":"Name",
		"recorder5":"Audiodauer",
		"recorder6":"Dateigröße",
		"recorder7":"Erstellungszeit",
		"recorder8":"arbeiten",
		"recorder9":"Beschreibung des Cloud-Raums",
		"recorder10":"dokumentieren",
		"recorder11":"OCR-Datei",
		"recorder12":"1. Wofür wird Cloud-Speicherplatz verwendet?",
		"recorder13":"Nach der Aufnahme mit dem Rekorder können Sie die Audio- und Transkriptionsdateien in den Cloud-Speicher hochladen. Auch wenn Sie den Rekorder nicht bei sich haben, können Sie auf den Cloud-Speicher zugreifen, um die Audiodaten anzusehen.",
		"recorder14":"2. Wie lade ich in den Cloud-Speicher hoch?",
		"recorder15":"Gehen Sie auf dem Rekorder zu [Meine Dateien], wählen Sie die Zieldatei aus und drücken Sie lange, um die Optionen anzuzeigen. Klicken Sie dann auf „Hochladen“, um die Datei in den Cloud-Speicher hochzuladen.",
		"recorder16":"3. Wie kann ich Dateien im Cloud-Speicher anzeigen/verwalten?",
		"recorder17":"Melden Sie sich auf der offiziellen BeiBo-Website an und wählen Sie „My-Recorder Cloud Disk“. Dort können Sie die hochgeladenen Recorder-Dateien anzeigen. Sie können die Zieldatei zum Herunterladen, Löschen usw. auswählen. Sie können den Cloud-Speicherplatz bereinigen, indem Sie die Cloud-Speicherplatz-Dateien löschen!",
		"recorder18":"Nicht transkribiert",
		"recorder19":"Zusammenfassung anzeigen",
		"recorder20":"Lautsprecher",
		"recorder21":"Sprechernamen bearbeiten",
		"recorder22":"Sicher",
		"recorder23":"herunterladen",
		"recorder24":"Inhalt herunterladen:",
		"recorder25":"Download-Einstellungen:",
		"recorder26":"Sprecher anzeigen",
		"recorder27":"Stornieren",
		"recorder28":"Link-Sharing",
		"recorder29":"Jeder, der den Link erhält, kann darauf zugreifen. Es wird nur das Lesen unterstützt. Der Link ist 7 Tage gültig.",
		"recorder30":"Link kopieren",
		"recorder31":"Scannen und schnell ansehen",
		"recorder32":"Intelligente Organisation",
		"recorder33":"Unterscheiden Sie zwischen Sprechern",
		"recorder34":"Intelligente Unterscheidung des transkribierten Textes entsprechend der Sprecherrolle",
		"recorder35":"Intelligente Regularisierung gesprochener Sprache",
		"recorder36":"Filtern Sie automatisch Modalpartikel, wiederholte Wörter und Pausenwörter",
		"recorder37":"Nicht-stimmliche Filterung",
		"recorder38":"Audio ohne Stimme oder Rauschen während der Wiedergabe automatisch überspringen",
		"recorder39":"Bitte wählen",
		"recorder40":"dokumentieren",
		"recorder41":"Audio",
		"recorder42":"Dokumente + Audio",
		"recorder43":"Hinweis",
		"recorder44":"Dieser Vorgang löscht Dateien. Möchten Sie fortfahren?",
		"recorder441":"Dieser Vorgang löscht alle Dateien. Möchten Sie fortfahren?",
		"recorder45":"Sicher",
		"recorder46":"Stornieren",
		"recorder47":"Erfolgreich gelöscht!",
		"recorder48":"Wiederhergestellt",
		"recorder49":"Noch keine Tags",
		"recorder50":"Speichern...",
		"recorder51":"Papierkorb",
	},
	personal:{
		"personal1":"Kontoeinstellungen",
		"personal2":"persönliche Informationen",
		"personal3":"Avatar",
		"personal4":"Dateien hochladen",
		"personal5":"Unterstützt JPG, JPEG, GIF, PNG-Stile, unterstützt Bilder innerhalb von 2M",
		"personal6":"Spitzname",
		"personal7":"Bitte geben Sie Ihren Spitznamen ein",
		"personal8":"Geschlecht",
		"personal9":"Herren",
		"personal10":"Vermissen",
		"personal11":"Vertraulichkeit",
		"personal12":"Geburtstag",
		"personal13":"Bitte wählen Sie Ihren Geburtstag",
		"personal14":"Beruf",
		"personal15":"Bitte wählen Sie Ihren Beruf",
		"personal16":"Bitte geben Sie Ihren Beruf ein (optional)",
		"personal17":"Nation",
		"personal18":"Wählen Sie Ihr Land",
		"personal19":"halten",
		"personal20":"persönliche Informationen",
		"personal21":"Kontosicherheit",
		"personal22":"Unterstützt nur Bilder innerhalb von 2M",
		"personal23":"Hochladen erfolgreich!",
		"personal24":"Änderung erfolgreich!",
		"personal25":"Kontosicherheit",
		"personal26":"Login-Passwort",
		"personal27":"Überarbeiten",
		"personal28":"E-Mail",
		"personal29":"ersetzen",
		"personal30":"Kontoauflösung",
		"personal32":"Möchten Sie Ihr Konto wirklich auflösen?",
		"personal33":"Nach der Abmeldung werden alle Inhalte Ihres Kontos gelöscht. Gehen Sie daher bitte vorsichtig vor.",
		"personal34":"Stornieren",
		"personal35":"Sicher",
		"personal36":"Authentifizierung",
		"personal37":"Um zu bestätigen, dass Sie die Operation durchführen, schließen Sie bitte die Identitätsprüfung per E-Mail-Bestätigungscode ab.",
		"personal38":"Mail",
		"personal39":"Bestätigungscode",
		"personal40":"Bitte geben Sie den Bestätigungscode ein",
		"personal41":"Nächster Schritt",
		"personal42":"Einrichten eines neuen Postfachs",
		"personal43":"Mail",
		"personal44":"Bitte geben Sie eine neue E-Mail-Adresse ein",
		"personal45":"Bestätigungscode",
		"personal46":"Bitte geben Sie den Bestätigungscode ein",
		"personal47":"Sicher",
		"personal48":"Legen Sie ein neues Anmeldekennwort fest",
		"personal49":"Neues Login-Passwort",
		"personal50":"Bitte geben Sie ein neues Passwort ein",
		"personal51":"Neues Passwort bestätigen",
		"personal52":"Bitte geben Sie Ihr neues Passwort erneut ein",
		"personal53":"Sicher",
		"personal54":"Erhalten",
		"personal55":"Fehler im E-Mail-Format",
		"personal56":"Austausch erfolgreich!",
		"personal57":"Bitte legen Sie das Passwort auf 6-16 Zeichen fest",
		"personal58":"Die von Ihnen zweimal eingegebenen Passwörter stimmen nicht überein",
		"personal59":"Änderung erfolgreich!",
		"personal60":"Abmeldung erfolgreich!",
	}
}